<template>
    <div class="t-lk-materials">
        <div class="t-lk-container">
            <lk-breadcrumbs-cmp :breadcrumbs="breadcrumbs"></lk-breadcrumbs-cmp>

            <banner-native-cmp
                v-if="banner"
                v-animation:bottom.delay
                :banner="banner"
            >
            </banner-native-cmp>

            <div v-animation:bottom.delay class="t-lk-title-link t-lk-container-mobile t-lk-materials__title">
                <h1 class="t-lk-title t-lk-title-link__title">{{ title }}</h1>
            </div>

            <div v-animation:bottom.delay class="t-lk-materials__filter">
                <filter-cmp
                    v-if="filter"
                    :filter="filter"
                    :name-btn="$root.staticText.lk.materialsFilterBtn"
                    :obj-undefined="{currentPage: undefined}"
                    :white="true"
                    :is-date="true"
                    :is-date-left="false"
                >
                </filter-cmp>
            </div>

            <div v-animation:bottom.delay class="t-lk-materials-id js-materials-vendors-id">
                <div class="t-lk-materials-id__th">
                    <div class="t-lk-materials-id__col-1">{{ $root.staticText.lk.materialsTableTh }}</div>
                    <div class="t-lk-materials-id__col-2">{{ $root.staticText.lk.materialsTableTh2 }}</div>
                </div>
                <div v-animation:bottom.delay v-for="(td, index) in table" class="t-lk-materials-id__item">
                    <div
                        class="t-lk-materials-id__row"
                        :class="{_open: activeIndex === index}"
                        @click="setActiveIndex(index)"
                    >
                        <div class="t-lk-materials-id__col-1">
                            <svg class="t-lk-materials-id__svg" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M3 7V17C3 17.5304 3.21071 18.0391 3.58579 18.4142C3.96086 18.7893 4.46957 19 5 19H19C19.5304 19 20.0391 18.7893 20.4142 18.4142C20.7893 18.0391 21 17.5304 21 17V9C21 8.46957 20.7893 7.96086 20.4142 7.58579C20.0391 7.21071 19.5304 7 19 7H13L11 5H5C4.46957 5 3.96086 5.21071 3.58579 5.58579C3.21071 5.96086 3 6.46957 3 7V7Z" stroke="#C0C0CC" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                            </svg>
                            <span class="t-lk-materials-id__name">{{ td.name }}</span>
                        </div>
                        <div class="t-lk-materials-id__col-2">{{ td.date }}</div>
                        <div class="t-lk-materials-id__col-3">
                            <div class="t-lk-materials-id__arrow">
                                <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path fill-rule="evenodd" clip-rule="evenodd" d="M3.69526 7.02925C3.95561 6.7689 4.37772 6.7689 4.63807 7.02925L10 12.3912L15.3619 7.02925C15.6223 6.7689 16.0444 6.7689 16.3047 7.02925C16.5651 7.2896 16.5651 7.71171 16.3047 7.97206L10.4714 13.8054C10.2111 14.0657 9.78895 14.0657 9.5286 13.8054L3.69526 7.97206C3.43491 7.71171 3.43491 7.2896 3.69526 7.02925Z" fill="#00b0bd"/>
                                </svg>
                            </div>
                        </div>
                    </div>
                    <transition name="fadeHeight">
                        <div v-if="activeIndex === index" class="t-lk-materials-id__container">
                            <div class="t-lk-materials-id__content">
                                <a :href="item.link" v-for="item in td.items.slice(0, 2)" download class="t-lk-materials-id-items">
                                    <div class="t-lk-materials-id-items__icon">
                                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M7 21H17C17.5304 21 18.0391 20.7893 18.4142 20.4142C18.7893 20.0391 19 19.5304 19 19V9.414C18.9999 9.1488 18.8946 8.89449 18.707 8.707L13.293 3.293C13.1055 3.10545 12.8512 3.00006 12.586 3H7C6.46957 3 5.96086 3.21071 5.58579 3.58579C5.21071 3.96086 5 4.46957 5 5V19C5 19.5304 5.21071 20.0391 5.58579 20.4142C5.96086 20.7893 6.46957 21 7 21Z" stroke="#C0C0CC" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                        </svg>
                                    </div>
                                    <div class="t-lk-materials-id-items__wrap">
                                        <div class="t-lk-materials-id-items__name">{{ item.name }}</div>
                                        <div class="t-file__row">
                                            <div class="t-file__type">{{ item.type }}</div>
                                            <div class="t-file__size">{{ item.size }}</div>
                                        </div>
                                    </div>
                                    <div class="t-lk-materials-id-items__right">
                                        <span>{{ $root.staticText.lk.requestsDownload }}</span>
                                        <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M3.33301 13.333V14.1663C3.33301 14.8294 3.5964 15.4653 4.06524 15.9341C4.53408 16.4029 5.16997 16.6663 5.83301 16.6663H14.1663C14.8294 16.6663 15.4653 16.4029 15.9341 15.9341C16.4029 15.4653 16.6663 14.8294 16.6663 14.1663V13.333M13.333 9.99967L9.99967 13.333M9.99967 13.333L6.66634 9.99967M9.99967 13.333V3.33301" stroke="#C0C0CC" stroke-width="1.3" stroke-linecap="round" stroke-linejoin="round"/>
                                        </svg>
                                    </div>
                                </a>
                                <transition name="fadeHeight">
                                    <div v-if="openItems">
                                        <a :href="item.link" v-for="item in td.items.slice(2)" download class="t-lk-materials-id-items">
                                            <div class="t-lk-materials-id-items__icon">
                                                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                    <path d="M7 21H17C17.5304 21 18.0391 20.7893 18.4142 20.4142C18.7893 20.0391 19 19.5304 19 19V9.414C18.9999 9.1488 18.8946 8.89449 18.707 8.707L13.293 3.293C13.1055 3.10545 12.8512 3.00006 12.586 3H7C6.46957 3 5.96086 3.21071 5.58579 3.58579C5.21071 3.96086 5 4.46957 5 5V19C5 19.5304 5.21071 20.0391 5.58579 20.4142C5.96086 20.7893 6.46957 21 7 21Z" stroke="#C0C0CC" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                                </svg>
                                            </div>
                                            <div class="t-lk-materials-id-items__wrap">
                                                <div class="t-lk-materials-id-items__name">{{ item.name }}</div>
                                                <div class="t-file__row">
                                                    <div class="t-file__type">{{ item.type }}</div>
                                                    <div class="t-file__size">{{ item.size }}</div>
                                                </div>
                                            </div>
                                            <div class="t-lk-materials-id-items__right">
                                                <span>{{ $root.staticText.lk.requestsDownload }}</span>
                                                <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                    <path d="M3.33301 13.333V14.1663C3.33301 14.8294 3.5964 15.4653 4.06524 15.9341C4.53408 16.4029 5.16997 16.6663 5.83301 16.6663H14.1663C14.8294 16.6663 15.4653 16.4029 15.9341 15.9341C16.4029 15.4653 16.6663 14.8294 16.6663 14.1663V13.333M13.333 9.99967L9.99967 13.333M9.99967 13.333L6.66634 9.99967M9.99967 13.333V3.33301" stroke="#C0C0CC" stroke-width="1.3" stroke-linecap="round" stroke-linejoin="round"/>
                                                </svg>
                                            </div>
                                        </a>
                                    </div>
                                </transition>

                                <transition name="fadeChange">
                                    <div
                                        v-if="td.items.length > 2 && !openItems"
                                        class="t-lk-materials-id-items__more"
                                        @click="openItems = true"
                                    >
                                        {{ $root.staticText.lk.materialsMore }}
                                        {{ td.items.length - 2 }}
                                        {{ $root.num2str(td.items.length - 2, $root.staticText.lk.materialsArr) }}
                                    </div>
                                </transition>

                            </div>
                        </div>
                    </transition>
                </div>
            </div>

            <pagination-cmp
                v-animation:bottom.delay
                v-if="pagination"
                :pagination="pagination"
                :name-current-page="'currentPage'"
                class="_lk"
            >
            </pagination-cmp>
        </div>
    </div>
</template>

<script>
    import Vue from "vue";
    import lkBreadcrumbs from "@components/lk/lk-breadcrumbs/lk-breadcrumbs";
    import bannerNative from "@components/lk/banner-native/banner-native";
    import filter from "@components/lk/lk-filter/lk-filter";
    import pagination from "@ui/pagination/pagination";
    import onScrollAnimate from "@assets/js/scrollAnimate";
    import {router} from "@src/routes";

    export default {
        name: "materials-vendors-id",
        data() {
            return {
                breadcrumbs: null,
                banner: null,
                title: null,
                filter: null,
                table: [],
                pagination: null,

                activeIndex: -1,
                openItems: false,
            }
        },
        components: {
            'filter-cmp': filter,
            'pagination-cmp': pagination,
            'lk-breadcrumbs-cmp': lkBreadcrumbs,
            'banner-native-cmp': bannerNative,
        },
        methods: {
            setData(data) {
                this.breadcrumbs = data.breadcrumbs;
                this.banner = data.banner;
                this.title = data.title;
                this.filter = data.filter;
                this.table = data.table;
                this.pagination = data.pagination;
            },
            setActiveIndex(index) {
                this.activeIndex = this.activeIndex === index ? -1 : index;
                this.openItems = false;
            },
            toggleFavorite(item) {
                let url = 'lk/materials-vendors/addFavorite';

                if (item.isFavorites) {
                    url = 'lk/materials-vendors/removeFavorite';
                }

                let fd = new FormData();
                fd.append('id', item.id);

                Vue.http.post(url, fd)
                    .then(response => response.json())
                    .then(data => {
                        if (data.success) {
                            item.isFavorites = !item.isFavorites;
                        }
                    })
                    .catch(() => {});
            },
        },
        beforeRouteUpdate(to, from, next) {
            let url = process.env.NODE_ENV !== 'production' ?
                'lk/materialsVendorsId.json' :
                to.path.substring(1).replace(router.history.base, '');

            this.$root.setDataAnimateFalse('.js-materials-vendors-id ');

            Vue.http.get(url, {params: to.query}).then(
                (data) => {
                    this.setData(data.data);
                    next();
                    setTimeout(() => {
                        onScrollAnimate();
                    }, 500);
                },
                (data) => {
                    if (data.status === 403) {
                        next({name: 'E403'})
                    } else {
                        next({name: 'E404'})
                    }
                }
            );
        },
        beforeRouteEnter(to, from, next) {
            let url = process.env.NODE_ENV !== 'production' ?
                'lk/materialsVendorsId.json' :
                to.path.substring(1).replace(router.history.base, '');

            Vue.http.get(url).then(
                (data) => {
                    next(vm => vm.setData(data.data));
                },
                (data) => {
                    if (data.status === 403) {
                        next({name: 'E403'})
                    } else {
                        next({name: 'E404'})
                    }
                }
            );
        },
    }
</script>

<style lang="sass">

</style>


// WEBPACK FOOTER //
// src/templates/pages/lk/materials/materials-vendors/id/index.vue